import React from 'react';
import { Carousel, Link } from '../components';
import { BlogCard } from '../components/Blog/BlogCard';
import './LatestPosts.scss';

export const LatestPosts = ({ posts }) => {
  if (!posts || posts.length < 1) return null;
  const responsive = {
    660: {
      items: 2,
    },
    0: {
      items: 1,
    },
  };
  return (
    <section className="latest-posts">
      <div className="wrapper">
        <div className="latest-posts-header">
          <span className="latest-posts-title">From the blog</span>
          <Link to="/blog" className="button">
            View all
          </Link>
        </div>
        <Carousel
          enabledBetween={[0, 960]}
          responsive={responsive}
          buttonsDisabled
          containerClassName="latest-posts-grid"
        >
          {posts.map(post => (
            <BlogCard key={post.slug} {...post} />
          ))}
        </Carousel>
      </div>
    </section>
  );
};
